import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Send } from 'lucide-react';
import { API } from '@/constants/data';

const TrabalheConosco = () => {
  const [formValues, setFormValues] = useState({});
  const [selectedExp, setSelectedExp] = useState([]);
  const [fields, setFields] = useState([]);
  const [expOpcoes, setExpOpcoes] = useState([]);
  const [personalidade, setPersonalidade] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const defaultFields = [
    { label: 'Por que você quer trabalhar conosco?', placeholder: 'Por que você quer trabalhar conosco? *', type: 'textarea', required: true },
    { label: 'Nome completo', placeholder: 'Nome completo *', type: 'text', required: true },
    { label: 'Quais softwares e equipamentos você domina?', placeholder: 'Quais softwares e equipamentos você domina? *', type: 'textarea', required: true },
    { label: 'Email', placeholder: 'Email *', type: 'email', required: true },
    { label: 'Qual o seu Bairro?', placeholder: 'Qual o seu Bairro? *', type: 'text', required: true },
    { label: 'CPF', placeholder: 'CPF *', type: 'text', required: true },
    { label: 'Data de Nascimento', placeholder: 'Data de Nascimento *', type: 'date', required: true },
    { label: 'Estado Civil', placeholder: 'Selecione *', type: 'select', required: true, options: 'Solteiro,Casado,Divorciado,Viúvo,Outro' },
    { label: 'CNH', placeholder: 'Selecione *', type: 'select', required: true, options: 'A,B,AB,D,AD,Não possuo CNH' },
    { label: 'Possui Veículo Próprio?', placeholder: 'Selecione *', type: 'select', required: true, options: 'Sim,Não' },
    { label: 'Qual o seu Objetivo Profissional?', placeholder: 'Qual o seu Objetivo Profissional? *', type: 'textarea', required: true },
    { label: 'Conte-nos sobre um serviço do qual você se orgulha', placeholder: 'Conte-nos sobre um serviço do qual você se orgulha *', type: 'textarea', required: true },
    { label: 'Qual é a sua maior motivação para trabalhar na área de audiovisual?', placeholder: 'Qual é a sua maior motivação para trabalhar na área de audiovisual? *', type: 'textarea', required: true },
    { label: 'Como você lida com prazos apertados e situações de alta pressão?', placeholder: 'Como você lida com prazos apertados e situações de alta pressão? *', type: 'textarea', required: true },
    { label: 'Quais são suas expectativas para o futuro na área de audiovisual?', placeholder: 'Quais são suas expectativas para o futuro na área de audiovisual?', type: 'textarea', required: false },
    { label: 'Seu melhor telefone de Contato', placeholder: 'Seu melhor telefone de Contato *', type: 'tel', required: true },
  ];
  const defaultExp = ['Som ao Vivo', 'Transmissão Simultânea', 'Informática', 'Painel de Led', 'Iluminação', 'OBS', 'RESOLUME', 'VMIX', 'Outro'];
  const personalidades = ['INTJ - Arquiteto', 'INTP - Lógico', 'ENTJ - Comandante', 'ENTP - Inovador', 'INFJ - Apoiador', 'INFP - Mediador', 'ENFJ - Protagonista', 'ENFP - Ativista', 'ISTJ - Prático', 'ISFJ - Defensor', 'ESTJ - Executivo', 'ESFJ - Cônsul', 'ISTP - Virtuoso', 'ISFP - Aventureiro', 'ESTP - Empreendedor', 'ESFP - Animador'];

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/settings/trabalhe_fields`),
      axios.get(`${API}/settings/experiencia_opcoes`),
    ]).then(([fRes, eRes]) => {
      setFields(fRes.data.value && fRes.data.value.length > 0 ? fRes.data.value : defaultFields);
      setExpOpcoes(eRes.data.value && eRes.data.value.length > 0 ? eRes.data.value : defaultExp);
    }).catch(() => { setFields(defaultFields); setExpOpcoes(defaultExp); });
  }, []);

  const toggleExp = (item) => {
    setSelectedExp(prev => prev.includes(item) ? prev.filter(e => e !== item) : [...prev, item]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let detalhes = '';
      fields.forEach(f => {
        const val = formValues[f.label] || '';
        if (val) detalhes += `${f.label}: ${val}\n`;
      });
      if (selectedExp.length > 0) detalhes += `Experiência em: ${selectedExp.join(', ')}\n`;
      if (personalidade) detalhes += `Personalidade (16personalities): ${personalidade}\n`;

      const nome = formValues[fields[0]?.label] || '';
      const emailField = fields.find(f => f.type === 'email');
      const phoneField = fields.find(f => f.type === 'tel');
      const email = formValues[emailField?.label] || 'nao@informado.com';
      const phone = formValues[phoneField?.label] || '';

      await axios.post(`${API}/contact`, {
        name: nome, email, phone,
        message: detalhes,
        form_type: 'trabalhe'
      });
      setSuccess(true);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const inputCls = "w-full bg-white border border-slate-200 text-[#0A2463] rounded-xl px-4 py-3 text-sm placeholder-slate-400 focus:outline-none focus:border-[#00A8E8] focus:ring-1 focus:ring-[#00A8E8]/30 transition-colors font-body";

  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/trabalhe-conosco' || location.hash === '#trabalhe-conosco') {
      setExpanded(true);
    }
  }, [location]);

  if (fields.length === 0) return null;

  return (
    <section id="trabalhe-conosco" className="relative py-20 lg:py-28 overflow-hidden" data-testid="trabalhe-conosco">
      <div className="absolute inset-0">
        <img src="https://static.prod-images.emergentagent.com/jobs/ea405bf3-7d8d-4b70-bd85-c90f31cfd218/images/5c7fea2272df11ef2482aaddca833552f1d7146ec7734833cae0868ef2434b06.png" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A2463]/80" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading text-4xl sm:text-5xl text-white uppercase tracking-wide">Trabalhe Conosco</h2>
          <p className="text-white/70 text-base font-body mt-4">Faça parte da equipe pioneira em audiovisual no Amazonas</p>
        </div>

        <div className="flex flex-col items-center mb-10">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-1">
            {[
              ['T', 'ALENTO'], ['R', 'ESPEITO'], ['A', 'PRENDIZADO'],
              ['B', 'OA VONTADE'], ['A', 'GILIDADE'], ['L', 'EALDADE'],
              ['H', 'ONESTIDADE'], ['O', 'PORTUNIDADE']
            ].map(([first, rest], i) => (
              <motion.p key={i} initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ delay: i * 0.06 }}
                className="font-heading text-lg sm:text-xl uppercase tracking-wider">
                <span className="text-[#00A8E8]">{first}</span>
                <span className="text-white">{rest}</span>
              </motion.p>
            ))}
          </div>
          <p className="text-white/50 text-xs font-body mt-4">Nossos valores definem quem somos.</p>
        </div>

        {!expanded && (
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="text-center">
            <button onClick={() => setExpanded(true)} data-testid="tc-expand-btn"
              className="bg-[#00A8E8] hover:bg-[#0090c9] text-white px-10 py-4 rounded-full font-bold font-body text-lg transition-all shadow-lg shadow-[#00A8E8]/30 inline-flex items-center gap-3">
              <Send size={20} /> Quero me Candidatar
            </button>
          </motion.div>
        )}

        {expanded && (
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
            className="max-w-3xl mx-auto">
            <form onSubmit={handleSubmit} className="bg-white/95 backdrop-blur-sm rounded-2xl border border-white/20 p-6 sm:p-8 space-y-5 shadow-2xl">
              {fields.slice(0, 2).map((field, i) => (
                <div key={i}>
                  {(field.type === 'select' || field.type === 'date') && (
                    <label className="block text-sm font-bold text-[#0A2463] font-body mb-1.5">{field.label}{field.required ? ' *' : ''}</label>
                  )}
                  {field.type === 'textarea' ? (
                    <textarea required={field.required} placeholder={field.placeholder || field.label} rows={3}
                      value={formValues[field.label] || ''}
                      onChange={e => setFormValues(v => ({...v, [field.label]: e.target.value}))}
                      className={inputCls} data-testid={`tc-field-${i}`} />
                  ) : (
                    <input type={field.type} required={field.required} placeholder={field.placeholder || field.label}
                      value={formValues[field.label] || ''}
                      onChange={e => setFormValues(v => ({...v, [field.label]: e.target.value}))}
                      className={inputCls} data-testid={`tc-field-${i}`} />
                  )}
                </div>
              ))}

              <div>
                <label className="text-[#0A2463] text-sm font-bold font-body mb-2 block">Em quais itens tem experiência?</label>
                <div className="flex flex-wrap gap-2">
                  {expOpcoes.map(op => (
                    <button key={op} type="button" onClick={() => toggleExp(op)}
                      className={`px-3 py-1.5 rounded-full text-sm font-body border transition-all ${selectedExp.includes(op) ? 'bg-[#00A8E8] text-white border-[#00A8E8]' : 'bg-white text-[#475569] border-slate-200 hover:border-[#00A8E8]'}`}>
                      {op}
                    </button>
                  ))}
                </div>
              </div>

              {fields.slice(2).map((field, i) => {
                const idx = i + 2;
                return (
                  <div key={idx}>
                    {(field.type === 'select' || field.type === 'date') && (
                      <label className="block text-sm font-bold text-[#0A2463] font-body mb-1.5">{field.label}{field.required ? ' *' : ''}</label>
                    )}
                    {field.type === 'textarea' ? (
                      <textarea required={field.required} placeholder={field.placeholder || field.label} rows={3}
                        value={formValues[field.label] || ''}
                        onChange={e => setFormValues(v => ({...v, [field.label]: e.target.value}))}
                        className={inputCls} data-testid={`tc-field-${idx}`} />
                    ) : field.type === 'select' ? (
                      <select required={field.required}
                        value={formValues[field.label] || ''}
                        onChange={e => setFormValues(v => ({...v, [field.label]: e.target.value}))}
                        className={inputCls} data-testid={`tc-field-${idx}`}>
                        <option value="">Selecione</option>
                        {(field.options || '').split(',').map((op, j) => <option key={j} value={op.trim()}>{op.trim()}</option>)}
                      </select>
                    ) : field.type === 'date' ? (
                      <input type="date" required={field.required}
                        value={formValues[field.label] || ''}
                        onChange={e => setFormValues(v => ({...v, [field.label]: e.target.value}))}
                        className={inputCls} data-testid={`tc-field-${idx}`} />
                    ) : (
                      <input type={field.type} required={field.required} placeholder={field.placeholder || field.label}
                        value={formValues[field.label] || ''}
                        onChange={e => setFormValues(v => ({...v, [field.label]: e.target.value}))}
                        className={inputCls} data-testid={`tc-field-${idx}`} />
                    )}
                  </div>
                );
              })}

              <div>
                <label className="text-[#0A2463] text-sm font-bold font-body mb-2 block">
                  Teste de personalidade (16personalities.com) <span className="text-slate-400 font-normal">- opcional</span>
                </label>
                <p className="text-[#475569] text-xs font-body italic mb-3 border-l-2 border-[#00A8E8] pl-3">
                  "Conhece-te a ti mesmo e conhecerás o universo e os deuses." — Sócrates
                </p>
                <a href="https://www.16personalities.com/br/teste-de-personalidade" target="_blank" rel="noopener noreferrer" className="text-[#00A8E8] text-xs font-body underline mb-2 inline-block">Fazer o teste aqui</a>
                <select value={personalidade} onChange={e => setPersonalidade(e.target.value)} className={inputCls} data-testid="tc-personalidade">
                  <option value="">Selecione seu resultado (opcional)</option>
                  {personalidades.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>

              <button type="submit" disabled={loading} data-testid="tc-enviar"
                className="w-full bg-[#0A2463] hover:bg-[#0A2463]/90 text-white py-3.5 rounded-xl font-bold font-body transition-colors flex items-center justify-center gap-2 text-base">
                {loading ? 'Enviando...' : <><Send size={20} /> Enviar Candidatura</>}
              </button>
              {success && (
                <div className="text-center p-4 bg-green-50 rounded-xl border border-green-200">
                  <p className="text-green-700 font-bold font-body">Candidatura enviada com sucesso!</p>
                  <p className="text-green-600 text-sm font-body mt-1">Entraremos em contato em breve.</p>
                </div>
              )}
            </form>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default TrabalheConosco;
